import {Nullable} from "../../../../../common/types/nullable-types";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {BannerConfig, VideoSlidesFilterConfig} from "../arenas/arena-base.model";
import {PromotionalBannerModel} from "./promotional-banner/promotional-banner.model";
import {ISwiperExtraContentViewModel} from "./swiper-extra-content-view-model.interface";
import {VideoSlidesFilterPreviewModel} from "./video-slides-filter-preview/video-slides-filter-preview.model";


export class SwiperExtraContentModel implements ISwiperExtraContentViewModel {
    constructor(public readonly services: IServiceFactoryExtended,
        public readonly arenaName: string,
        readonly bannerConfig: BannerConfig | null,
        readonly videoSlidesFilterConfig: Nullable<VideoSlidesFilterConfig>) {
        this._promotionalBanner = new PromotionalBannerModel(this.services, this.arenaName, this.bannerConfig);
        this._videoSlidesFilter = new VideoSlidesFilterPreviewModel(this.services, this.arenaName, this.videoSlidesFilterConfig);

    }

    private _promotionalBanner: PromotionalBannerModel;
    private _videoSlidesFilter: VideoSlidesFilterPreviewModel;
    renderExtraContent(listPosition: number, numberOfListsInCurrentArena: number): React.ReactElement {
        return (
            <>
                {this._promotionalBanner.render(listPosition, numberOfListsInCurrentArena)}
                {this._videoSlidesFilter.render(listPosition)}
            </>
        )
    }

}